import { render, staticRenderFns } from "./CheckoutAddress.vue?vue&type=template&id=8077501a"
import script from "./CheckoutAddress.vue?vue&type=script&lang=ts"
export * from "./CheckoutAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8077501a')) {
      api.createRecord('8077501a', component.options)
    } else {
      api.reload('8077501a', component.options)
    }
    module.hot.accept("./CheckoutAddress.vue?vue&type=template&id=8077501a", function () {
      api.rerender('8077501a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/CheckoutAddress.vue"
export default component.exports